import type { RouteViewModel } from '../../../types/routeViewModel';

/** GAP-P1-10 / TP §6.10 — carrier finalize completes the whole Route on multi-app routes. */
export const CARRIER_MULTI_APPLICATION_ROUTE_SCOPE_MESSAGE =
  'На маршруте несколько заявок: при смене перевозчика завершится весь маршрут целиком, не одна заявка.';

export const CARRIER_ROUTE_CREATE_MULTI_APP_PREFILL_NOTE =
  'Deep link может подставить одну заявку — в Route Create выберите груз для всех остатков successor-маршрута.';

export function countLinkedApplications(view: RouteViewModel): number {
  return view.operation?.linkedApplicationsSummary?.length ?? 0;
}

export function isMultiApplicationRoute(view: RouteViewModel): boolean {
  return countLinkedApplications(view) > 1;
}
